import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';

import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { Store } from '@ngxs/store';
import { AccountState } from '@state/account/state';
import { Account } from 'app/core/models/account.types';
import { FileResource, Document } from 'app/shared/modules/folders/folders.types';
import { SharedResourcesService } from 'app/modules/shared-resources/shared-resources.service';

@Component({
  selector: 'shared-resource-file-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
})
export class SharedResourceFileDetailsComponent extends OnDestroyMixin implements OnInit {
  selectedFile: FileResource;
  selectedDocument: Document;
  documentVersionsDataSource: MatTableDataSource<any>;
  documentVersionsColumns: string[];
  account: Account;

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _sharedResourcesService: SharedResourcesService,
    private readonly store: Store,
  ) {
    super();
    this.documentVersionsDataSource = new MatTableDataSource();
    this.documentVersionsColumns = ['version', 'created_by', 'created_at', 'actions'];
    this.account = this.store.selectSnapshot(AccountState.getAccount);
  }

  ngOnInit(): void {
    this._sharedResourcesService.file$.pipe(untilComponentDestroyed(this)).subscribe((fileResource: FileResource) => {
      this.selectedFile = fileResource;
      this.documentVersionsDataSource.data = fileResource.documents.sort((a, b) => (a.id < b.id ? 1 : -1));
      this.setSelectedDocument();
      this._changeDetectorRef.markForCheck();
    });
  }

  setSelectedDocument(document?: Document): void {
    if (document) {
      this.selectedDocument = document;
    } else {
      if (this.selectedFile.documents.length > 0) {
        this.selectedDocument = this.selectedFile.documents[0];
      }
    }
  }

  downloadDocument(document: Document): void {
    window.open(document.original_url, '_blank');
  }

  trackByFn(index: number, item: any): any {
    return item.id || index;
  }
}
